var _rect, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartphone = function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 2.85,
    width: 12.3,
    height: 18.3,
    rx: 1.738,
    stroke: "#58B847",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "smartphone_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 17,
    width: 7,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.968h-.057v1.711H15.557v-1.711H9.5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.114
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#smartphone_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "smartphone_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 8.5,
    y: 17.027,
    width: 8,
    height: 3,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 17.027h8v3h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.897 19.589h-4.794c-.334 0-.603-.334-.603-.74 0-.405.27-.738.603-.738h4.794c.332 0 .603.331.603.738s-.27.742-.603.742"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.897 19.589h-4.794c-.334 0-.603-.334-.603-.74 0-.405.27-.738.603-.738h4.794c.332 0 .603.331.603.738s-.27.742-.603.742",
    fill: "#58B847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.897 19.475h-4.794v.228h4.794v-.228Zm-4.794 0c-.25 0-.49-.26-.49-.626h-.227c0 .445.3.854.717.854v-.228Zm-.49-.626c0-.365.24-.624.49-.624v-.228c-.417 0-.717.407-.717.852h.228Zm.49-.624h4.794v-.228h-4.794v.228Zm4.794 0c.249 0 .49.258.49.624h.227c0-.447-.301-.852-.717-.852v.228Zm.49.624c0 .367-.242.628-.49.628v.227c.416 0 .717-.408.717-.855h-.228Z",
    fill: "#fff",
    mask: "url(#smartphone_svg__b)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V3h6v1.5Z",
    fill: "#58B847"
  })));
};
export default SvgSmartphone;